import React, { useEffect, FunctionComponent } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getCookieByName } from 'Constants/functions'
import { getIsArtist, getUser, getIsAuth } from 'Redux/selectors/auth'
import { IntercomProvider, useIntercom } from 'react-use-intercom'
import ErrorBoundary from 'Shared/components/ErrorBoundary'
import get from 'lodash/get'
import { setGcidToUser as onSetGcidToUser } from 'Redux/actions/auth'
import { APP } from 'Configs/App'
import { IntercomSetupProps } from './IntercomSetupProps'
import { User } from '../../Types'

export const IntercomSetup: FunctionComponent<IntercomSetupProps> = ({
  name,
}) => {
  const { boot, update } = useIntercom()
  const user: User = useSelector(getUser)
  const greetingName =
    user?.first_name?.slice(0, 1).toUpperCase() + user?.first_name?.slice(1)

  useEffect(() => {
    update({
      customAttributes: {
        name,
      },
    })
  }, [name])

  useEffect(() => {
    boot({
      customAttributes: {
        name: greetingName,
      },
    })
  }, [])

  return null
}

const MainWrapper: FunctionComponent = ({ children }) => {
  const dispatch = useDispatch()

  const isArtist: boolean = useSelector(getIsArtist)
  const user: User = useSelector(getUser)
  const isAuth: boolean = useSelector(getIsAuth)

  useEffect(() => {
    if (user && !user.gcid) {
      const adminItem = localStorage.getItem('admin')
      const isAdmin: boolean = adminItem ? JSON.parse(adminItem) : false
      const fullGcid = getCookieByName('_ga')
      const gcid = fullGcid ? fullGcid.slice(6) : undefined

      if (!isAdmin && gcid && isAuth) dispatch(onSetGcidToUser(gcid, isArtist))
    }
  }, [])

  return (
    <IntercomProvider
      // @ts-ignore
      appId={APP.INTERCOM_APP_ID}
    >
      <ErrorBoundary>
        <IntercomSetup name={get(user, 'first_name', 'there')} />

        <div className="theme-light ltr-support" dir="ltr">
          <ErrorBoundary>
            <div className="wrapper">{children}</div>
          </ErrorBoundary>
        </div>
      </ErrorBoundary>
    </IntercomProvider>
  )
}

export default withRouter(MainWrapper)
